<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
          color="#0F998E"
          class="white--text float-right"
          v-on="on"
        >
          Dodaj artikel
          <v-icon right dark>mdi-plus</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title
        primary-title
      >
        Artikel
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              label="Ime artikla"
              v-model="searchString"
              ref="search"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-container class="results-container">
          <v-row
            v-if="filteredArticles"
            class="results"
          >
            <v-col
              cols="12"
              v-for="item of filteredArticles"
              :key="item.id"
            >
              <v-btn
                style="width: 100%"
                class="float-right"
                :outlined="selectedArticles.includes(item.id)"
                @click="toggleSelectedArticle(item)"
              >
                {{item.name}}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#0F998E"
          text
          @click="dialog = false"
        >
          Prekliči
        </v-btn>
        <v-btn
          color="#0F998E"
          text
          @click="saveSelected"
        >
          Dodaj
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { siIncludes } from '@/utils/str'

export default {
  props: {
    levelId: {
      required: true,
      type: Number
    },
    levelCategories: {
      required: true,
      type: Array
    },
    levelArticles: {
      required: true,
      type: Array
    },
    allArticles: {
      default: () => [],
      type: Array
    }
  },
  data () {
    return {
      dialog: false,
      searchString: '',
      selectedArticles: []
    }
  },
  computed: {
    allArticlesThatAreNotAdded () {
      const addedIds = this.levelArticles.map(ar => ar.id)
      return this.allArticles.filter(ar => {
        return !addedIds.includes(ar.id)
      })
    },
    filteredArticles () {
      return this.allArticlesThatAreNotAdded.filter(article => siIncludes({ haystack: article.name, needle: this.searchString }))
    }
  },
  methods: {
    ...mapActions('articles', { loadArticles: 'loadItems' }),
    ...mapActions('levels', ['addArticle']),
    toggleSelectedArticle (article) {
      if (this.selectedArticles.includes(article.id)) {
        this.selectedArticles = this.selectedArticles.filter(ar => ar !== article.id)
      } else {
        this.selectedArticles.push(article.id)
      }
    },
    saveSelected () {
      const actions = []
      this.selectedArticles.forEach(articleId => {
        actions.push(this.addArticle({ levelId: this.levelId, articleId }))
      })
      Promise.all(actions)
        .then(() => {
          this.dialog = false
          this.selectedArticles = []
        })
    }
  },
  watch: {
    dialog (dialog) {
      if (dialog) {
        setTimeout(() => {
          this.$refs.search.focus()
        }, 50)
      }
      this.searchString = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.results-container {
  max-height: 400px;
  overflow-y: auto;
}
</style>
